import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "navbar-brand logo",
  href: "javascript:void(0)"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CloudImage = _resolveComponent("CloudImage");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["d-flex justify-content-center align-items-center masthead", {
      sticky: $setup.y > 50
    }])
  }, [_createElementVNode("a", _hoisted_1, [_createVNode(_component_router_link, {
    to: "/"
  }, {
    default: _withCtx(() => [$setup.y < 50 ? (_openBlock(), _createBlock(_component_CloudImage, {
      key: 0,
      class: "img-fluid logo-white",
      imageName: "logo-m_g3przw",
      alt: "G1G logo"
    })) : (_openBlock(), _createBlock(_component_CloudImage, {
      key: 1,
      class: "img-fluid logo-white",
      imageName: "logo-m_g3przw",
      alt: "G1G logo"
    }))]),
    _: 1
  })]), _createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.toIteraTravelReasons && _ctx.toIteraTravelReasons(...args)),
    class: "btn-primary check-prices"
  }, "Check prices ")], 2);
}